<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :loading="loading"
    :height="height"
    size="mini"
    resizable
    border
    :edit-config="{ trigger: 'click', mode: 'cell' }"
    :edit-rules="editRules"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 500 },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
      editRules: {
        qty: [
          {
            required: true,
            message: this.$l('form_placeholder_quantity') || '请输入数量',
          },
        ],
      },
    }
  },
  methods: {
    async getTableData() {
      const $vxeGrid = this.$refs.vxeGrid
      return await $vxeGrid.getTableData().tableData
    },
    removeCheckboxRow() {
      const $vxeGrid = this.$refs.vxeGrid
      const data = $vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      $vxeGrid.removeCheckboxRow()
    },
    async insertAt(records, active = false) {
      const $vxeGrid = this.$refs.vxeGrid
      if (!$vxeGrid) return
      const { row: newRow } = await $vxeGrid.insertAt(records, null)
      if (active) await $vxeGrid.setActiveCell(newRow, 'qty')
    },
    validEvent() {
      return this.$refs.vxeGrid
        .fullValidate(true)
        .then(() => true)
        .catch(() => false)
    },
  },
}
</script>
